export default __webpack_public_path__ + "static/bara_studio-25940c18bd3053ed3d8122c689c886fe.png";